import api from "./api";

export const getURLRedirectConectMeta = async (idCompany: string) => {
    const response = await api.get(`whatsapp/signup-url/?companyId=${idCompany}`);
    return response.data;
};

export const getWhatsAppEmbeddedSignupConfig = async () => {
    const response = await api.get('whatsapp/embedded-signup-config');
    return response.data;
};

export const completeWhatsAppEmbeddedSignup = async (payload: {
    companyId: string;
    code: string;
    waba_id?: string;
    phone_number_id?: string;
    coexistence?: boolean;
}) => {
    const response = await api.post('whatsapp/embedded-signup', payload);
    return response.data;
};

export const getWhatsAppStatus = async (companyId: string) => {
    const response = await api.get(`whatsapp/status/${companyId}`);
    return response.data;
};

export const getWhatsAppTemplates = async (companyId: string) => {
    const response = await api.get(`whatsapp/templates/${companyId}`);
    return response.data;
};

export const createWhatsAppTemplate = async (data: any) => {
    const response = await api.post(`whatsapp/templates`, data);
    return response.data;
    // console.log('Dados enviados para criar template:', data);
};

export const sendWhatsAppMessage = async (data: any) => {
    const response = await api.post(`whatsapp/send`, data);
    return response.data;
};